module.exports = __webpack_public_path__ + "static/media/next.d063d488.svg";